import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';
import DraftImportButton from './DraftImportButton';
import DraftTable from './PostsTable/DraftTable';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

const sortingOptions = [
  {
    label: 'Drafts',
  },
  {
    label: 'Scheduled',
  },
  {
    label: 'Published',
  },
];

const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.card,
  },
}));

const Drafts = props => {
  let sortByNr = 0;
  if (props.sortby === 'scheduled') sortByNr = 1;
  else if (props.sortby === 'published') sortByNr = 2;

  const [sortby, setSortBy] = useState(sortByNr);

  const { classes } = useStyles();
  const isMobileView = useMediaQuery('(max-width: 576px)');

  return (
    <>
      <Paper className={classes.root}>
        <Tabs
          centered={!isMobileView}
          fullWidth={isMobileView}
          indicatorColor="primary"
          textColor="primary"
          onChange={(event, newValue) => {
            setSortBy(newValue);
          }}
          value={sortby}
        >
          {sortingOptions.map(topic => {
            return <Tab label={topic.label} key={topic.label} />;
          })}
          <DraftImportButton />
        </Tabs>
        <Divider />
      </Paper>
      <CustomTabPanel value={sortby} index={0}>
        <DraftTable sortby={0} />
      </CustomTabPanel>
      <CustomTabPanel value={sortby} index={1}>
        <DraftTable sortby={1} />
      </CustomTabPanel>
      <CustomTabPanel value={sortby} index={2}>
        <DraftTable sortby={2} />
      </CustomTabPanel>
    </>
  );
};

export default Drafts;
